// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"783":"159334a1","993":"bb158106"}[chunkId] + ".chunk.css";
};